import { Box, Container, Tab } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useHistory, useLocation } from 'react-router-dom';
import { ReportingGenerationTab } from './generation/ReportingGenerationTab';
import { Props } from '../container';
import { ReportingLibraryTable } from './library/ReportingLibraryTable';
import { REPORTING_CURRENT_TAB_KEY, REPORTING_LIBRARY_TAB_KEY, REPORTING_GENERATION_TAB_KEY, REPORTING_PARAMETERS_KEY } from '../constants';
import { REPORTING_SCHEDULER_KEY } from './../constants';
import { ReportingScheduler } from './scheduler/ReportingScheduler';
import { ReportingParametersTable } from './parameters/ReportingParametersTable';

export const ReportingComponent = (props: Props): JSX.Element => {
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const currentTab = searchParams.get(REPORTING_CURRENT_TAB_KEY);

  const changeTab = (value: string) => {
    searchParams.set(REPORTING_CURRENT_TAB_KEY, value);
    history.replace({ search: searchParams.toString() });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => changeTab(newValue);

  useEffect(() => {
    if (!searchParams.get(REPORTING_CURRENT_TAB_KEY)) {
      changeTab(REPORTING_GENERATION_TAB_KEY);
    }
  }, []);

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <TabContext value={currentTab || REPORTING_GENERATION_TAB_KEY}>
        <TabList TabIndicatorProps={{ style: { height: '4px' } }} onChange={handleChange}>
          <Tab value={REPORTING_GENERATION_TAB_KEY} label="REPORT GENERATION" />
          <Tab value={REPORTING_LIBRARY_TAB_KEY} label="REPORT LIBRARY" />
          {props.hasClientEditAdminOnlyPermission && <Tab value={REPORTING_SCHEDULER_KEY} label="REPORT SCHEDULER" />}
          <Tab value={REPORTING_PARAMETERS_KEY} label="REPORT PARAMETERS" />
        </TabList>
        <TabPanel value={REPORTING_GENERATION_TAB_KEY}>
          <ReportingGenerationTab {...props} />
        </TabPanel>
        <TabPanel value={REPORTING_LIBRARY_TAB_KEY}>
          <Box display="flex" flexDirection="column" gap={2}>
            <ReportingLibraryTable {...props} />
          </Box>
        </TabPanel>
        {props.hasClientEditAdminOnlyPermission && (
          <TabPanel value={REPORTING_SCHEDULER_KEY}>
            <ReportingScheduler {...props} />
          </TabPanel>
        )}
        <TabPanel value={REPORTING_PARAMETERS_KEY}>
          <Box display="flex" flexDirection="column" gap={2}>
            <ReportingParametersTable {...props} />
          </Box>
        </TabPanel>
      </TabContext>
    </Container>
  );
};
